import { render, staticRenderFns } from "./UsageSettings.vue?vue&type=template&id=35fb94fe"
import script from "./UsageSettings.vue?vue&type=script&lang=js"
export * from "./UsageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports